module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/vip4-404eabbc4d2a1798928bebde907816b6.png";